import React, {useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'

type Props = {
  values: string[]
  onChange: (val: string[]) => void
  placeholder?: string
}

export function HobbiesAutocompleteField({
  values,
  onChange,
  placeholder = 'Type and press Enter...',
}: Props) {
  const [query, setQuery] = useState('')
  const [collection, setCollection] = useState<string[]>([])

  const normalize = (val: string) => val.trim()

  const handleAdd = (value: string) => {
    const clean = normalize(value)
    if (!clean) return

    // evitar duplicados en values
    if (!values.includes(clean)) {
      onChange([...values, clean])
    }

    // guardar como sugerencia si no existe
    if (!collection.includes(clean)) {
      setCollection((prev) => [...prev, clean])
    }

    setQuery('')
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd(query)
    }
  }

  const handleRemove = (lang: string) => {
    onChange(values.filter((v) => v !== lang))
  }

  return (
    <div className='nb-language-autocomplete'>
      <div className='nb-language-wrapper'>
        {values.map((lang) => (
          <div key={lang} className='nb-language-chip'>
            <div className='nb-language-chip-text'>{lang}</div>
            <div
              className='nb-language-chip-remove'
              onClick={() => handleRemove(lang)}
            >
              <KTSVG path={toAbsoluteUrl('/media/svg/nobilis/remove.svg')} />
            </div>
          </div>
        ))}

        <input
          className='nb-language-input'
          name='hobbies'
          value={query}
          placeholder={placeholder}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    </div>
  )
}
